// extracted by mini-css-extract-plugin
export var animationFadeUp = "style-module--animationFadeUp--15950";
export var card = "style-module--card--86805";
export var card__image = "style-module--card__image--5ad34";
export var card__link = "style-module--card__link--fb8a2";
export var card__title = "style-module--card__title--455a5";